import * as Sentry from '@sentry/react'

export const sendErrorToSentry = (error?: any, message?: string) => {
  Sentry.captureException(error, {
    tags: {
      message: message || '',
    },
  })
}
